import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faSquareFacebook, faSquareInstagram, faLinkedin, faSquareXTwitter, faSquareYoutube,
} from '@fortawesome/free-brands-svg-icons';
import PropTypes from 'prop-types';
import styles from './ListingSocialDisplay.scss';
import { withHttp } from '../../../utils/url';

const ListingSocialDisplay = ({
    twitterUsername,
    facebookUrl,
    instagramUrl,
    linkedinUrl,
    youtubeUrl,
}) => (
    <div className={styles.container}>
        <span>Find Us On:</span>
        <div className={styles.socialIconContainer}>
            {twitterUsername && (
                <a
                    href={`https://x.com/${twitterUsername}`}
                    rel="noreferrer"
                    target="_blank"
                    aria-label="X"
                >
                    <FontAwesomeIcon
                        className={styles.socialIcon}
                        icon={faSquareXTwitter}
                    />
                </a>
            )}
            {facebookUrl && (
                <a
                    href={withHttp(facebookUrl)}
                    rel="noreferrer"
                    target="_blank"
                    aria-label="Facebook"
                >
                    <FontAwesomeIcon
                        className={styles.socialIcon}
                        icon={faSquareFacebook}
                    />
                </a>
            )}
            {instagramUrl && (
                <a
                    href={withHttp(instagramUrl)}
                    rel="noreferrer"
                    target="_blank"
                    aria-label="Instagram"
                >
                    <FontAwesomeIcon
                        className={styles.socialIcon}
                        icon={faSquareInstagram}
                    />
                </a>
            )}
            {linkedinUrl && (
                <a
                    href={withHttp(linkedinUrl)}
                    rel="noreferrer"
                    target="_blank"
                    aria-label="LinkedIn"
                >
                    <FontAwesomeIcon
                        className={styles.socialIcon}
                        icon={faLinkedin}
                    />
                </a>
            )}
            {youtubeUrl && (
                <a
                    href={withHttp(youtubeUrl)}
                    rel="noreferrer"
                    target="_blank"
                    aria-label="Youtube"
                >
                    <FontAwesomeIcon
                        className={styles.socialIcon}
                        icon={faSquareYoutube}
                    />
                </a>
            )}
        </div>
    </div>
);

ListingSocialDisplay.propTypes = {
    twitterUsername: PropTypes.string,
    facebookUrl: PropTypes.string,
    instagramUrl: PropTypes.string,
    linkedinUrl: PropTypes.string,
    youtubeUrl: PropTypes.string,
};

ListingSocialDisplay.defaultProps = {
    twitterUsername: '',
    facebookUrl: '',
    instagramUrl: '',
    linkedinUrl: '',
    youtubeUrl: '',
};

export default ListingSocialDisplay;
